import React from 'react';

const Youtube = () => {
    return (
        <svg
            width="49"
            height="35"
            viewBox="0 0 49 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.99356 0.578687C14.6626 0.204922 20.1724 0.0177002 24.3747 0.0177002C28.5769 0.0177002 33.9939 0.204922 38.7558 0.578687C44.2655 1.04742 47.0675 1.98149 47.8141 7.49843C48.1873 10.0239 48.375 13.4827 48.375 17.0359C48.375 20.589 48.1873 24.1415 47.8141 26.5727C47.0675 32.1839 44.2655 33.0257 38.7558 33.4931C33.9939 33.9605 28.5769 34.0541 24.3747 34.0541C20.1724 34.0541 14.6626 33.9605 9.99356 33.4931C4.48379 33.0257 1.58901 32.1839 0.841769 26.5727C0.561301 24.1415 0.375 20.589 0.375 17.0359C0.375 13.4827 0.561301 10.0239 0.841769 7.49843C1.58901 1.98149 4.48379 1.04742 9.99356 0.578687Z"
                fill="url(#paint0_linear_13763_944)"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.5742 9.61768L31.7924 16.9873L19.5742 24.454V9.61768Z"
                fill="#F1F6FA"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_13763_944"
                    x1="24.375"
                    y1="34.0541"
                    x2="24.375"
                    y2="0.0177002"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#022139" />
                    <stop offset="1" stop-color="#014B86" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default Youtube;
